import { IWithWorksheetInjectedProps, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, RadioGroup, TextOutput } from '../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, PageSection, SectionGroup } from '../../../../Layout';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';
import { MaterialSuitability, RolledBy } from '../types';
import PlasticLimitTrialSection from './PlasticLimitTrialSection';

let AsPlasticLimitSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const llResultNotObtainable = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false))
  );
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('PlasticLimit.NonPlastic'), valueOrDefault(false), (np) => !np)
  );

  return (
    <PageSection heading="Plastic Limit">
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          name="PlasticLimit.RolledBy"
          options={[RolledBy.Hand, RolledBy.GlassPlates].map((e) => ({ label: e, value: e }))}
        />
      </ListFieldSection>
      <SectionGroup heading="Plastic Limit Determination">
        <NamePrefixModifier appendNamePrefix="PlasticLimit">
          <ListFieldSection>
            <FieldSet>
              <Field
                input={<RadioGroup />}
                name="MaterialSuitability"
                options={[
                  { label: 'The material is suitable for testing.', value: MaterialSuitability.MaterialSuitable },
                  {
                    label: 'Not tested - LL could not be obtained.',
                    value: MaterialSuitability.NotTested,
                    disabled: !llResultNotObtainable,
                  },
                  { label: 'Result cannot be determined.', value: MaterialSuitability.ResultNotDetermined },
                ]}
              />
            </FieldSet>
          </ListFieldSection>
          {determinationPerformed && (
            <>
              <ListFieldSection>
                <WorksheetBalanceFieldSet name="Balance" />
              </ListFieldSection>

              <ListFieldSection>
                <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Oven" />
                <Field input={<NumericInput />} name="DryingTemperature" />
                <WorksheetBalanceFieldSet name="DryMassBalance" />
              </ListFieldSection>
              <PlasticLimitTrialSection />
            </>
          )}
        </NamePrefixModifier>
      </SectionGroup>

      <ListFieldSection heading="Result">
        {determinationPerformed ? (
          <Field input={<TextOutput />} name="Results.PlasticLimit" />
        ) : (
          <Field input={<TextOutput />} label="Average Water Content (%)" value="N/A" />
        )}
        <Field input={<TextOutput />} name="Results.PlasticLimitText" />
      </ListFieldSection>
    </PageSection>
  );
};

AsPlasticLimitSection = withInjectedProps(AsPlasticLimitSection);

export { AsPlasticLimitSection };
export default AsPlasticLimitSection;
